<script>
  import config from '../../libs/config.js';
  import func from '../../libs/functions.js';
  import api from '../../api'
  import _ from 'lodash'

  import tippy from 'tippy.js'

  import iziToast from 'izitoast'
  import 'izitoast/dist/css/iziToast.min.css';

  import _system from '../../libs/system';

	import { mapGetters, mapActions } from 'vuex'

  import { db, storage } from '../../firebase';
	
	export default 
	{
    name: 'WhiteLabel',
		data() 
        {
        	return {
            func: func,
            attachmentPreview: '',
            platforms: [],
            attachment: {},
            subdomain: '',
            image: '',
            cname: '',
            color: '',
            loading: false
        	}
        },
        computed: {
          ...mapGetters('session', ['isLoggedIn', 'getUser', 'getRole', 'getBrand']),
          ...mapGetters('networks', ['networks','networksById']),
          ...mapGetters('workspaces', ['currentWorkspaceSettings','currentWorkspace','workspaces', 'workspacesById']),
          ...mapGetters('tags', ['tags', 'tagsByName', 'tagsByTypeName']),  
          ...mapGetters('workspaceusers', ['workspaceusers']),
          ...mapGetters('accounts', ['accounts']),
          imwage(){
            if(this.attachmentPreview.length) {
              return this.attachmentPreview;
            }else if(this.getBrand && this.getBrand.avatar){
              return 'data:'+ this.getBrand.avatar.contentType +';base64,' + this.getBrand.avatar.data.toString('base64');
            }else{
              return '/img/logo_dark2.png'
            }  
          }
        },
      methods: {
        ...mapActions('session', ['setUser', 'setBrand']),
        ...mapActions('workspaces', ['setWorkspaces', 'setCurrentWorkspaceSettings']),
        ...mapActions('workspaceusers', ['setWorkspaceusers']),
        ...mapActions('networks', ['setNetworks']),
        onChildUpdate (newValue) {
          console.log(newValue);
        },
        update(){

          if(this.currentWorkspace.name.length < 2) return alert('Type at least 2 character!');

          this.loading = true;
          let payload = {
            query: {
              workspaceId: this.currentWorkspace._id
            },
            body: {
              name: this.currentWorkspace.name
            }
          }
          _system.services.workspaces.update(payload, (err, res) => {
            if(err) return alert(err.message);


            payload.body = {
              color: this.color
            }

            _system.services.workspaces.updateColor(payload, (err, res) => {
              if(err) return alert(err.message);


            });

             if(this.attachmentPreview.length){
              const formDataImage = new FormData();
              formDataImage.append('file', this.attachment);

              payload.body = {}
              payload.formData = formDataImage

              _system.services.workspaces.updateAvatar(payload, (err, res) => {
                if(err) return alert(err.data.message)

                this.loading = false;
                    iziToast.success({
                      position: 'bottomCenter',
                      title: 'Updated',
                  });

              });
             }else{
               this.loading = false;
                  iziToast.success({
                      position: 'bottomCenter',
                      title: 'Updated',
                  });
             }
          })
        },
        saveImage(){

          console.log(this.attachment)
            
              const formDataImage = new FormData();
              formDataImage.append('file', this.attachment);

            let payload = {
              query: {
                userId: this.getUser._id
              }
            };
              payload.body = {}
              payload.formData = formDataImage

              _system.services.user.whiteLabelAvatarUpdate(payload, (err, res) => {
                if(err) return alert(err.data.message)

                res.brand.loaded = true;
                this.setBrand(res.brand)

                    storage.ref(this.getBrand.cname[0].name.replaceAll('.','')).put(this.attachment)
                      .then((snapshot)=>{
                        return snapshot.ref.getDownloadURL();
                      }).then((downloadURL)=>{
                        console.log('image uploaded')
                        db.collection('domains').doc(this.getBrand.cname[0].name.replaceAll('.','')).set({
                          url: downloadURL,
                          color: this.color
                        }).then(() => {
                          console.log('image inserted into db!')
                          location.reload();
                        }).catch(()=>{
                          console.log('Error while saving the data, contact support.')
                        })
                      }).catch(()=>{
                        console.log('Error uploading file');
                    })


                this.loading = false;
                    iziToast.success({
                      position: 'bottomCenter',
                      title: 'Updated',
                  });

                  //location.reload()

              });
             
        },
        saveSubdomain(){

          this.loading = true;

            let payload = {
              query: {
                userId: this.getUser._id
              }
            };
              payload.body = {"name": this.subdomain, "kind":"CNAME","data":"app.juphy.com"}

              _system.services.user.subdomainCreate(payload, (err, res) => {
                if(err) return alert(err.data.message)

                res.brand.loaded = true;
                this.setBrand(res.brand)

                this.loading = false;
                    iziToast.success({
                      position: 'bottomCenter',
                      title: 'Subdomain Updated',
                  });

              });
             
        },
        saveCname(){
            this.loading = true;
            let payload = {
              query: {
                userId: this.getUser._id
              }
            };
              payload.body = {"name":this.cname.trim(),"ip_address":"167.99.36.4"}

              _system.services.user.cnameCreate(payload, (err, res) => {
                if(err) return alert(err.data.message)

                res.brand.loaded = true;
                this.setBrand(res.brand)

                this.loading = false;
                    iziToast.success({
                      position: 'bottomCenter',
                      title: 'Domain Updated',
                  });

              });
             
        },
        deleteSubdomain(){
            this.loading = true;
            let payload = {
              query: {
                userId: this.getUser._id,
                name: this.getBrand.subdomain[0].records[0].name
              }
            };

              _system.services.user.deleteSubdomain(payload, (err, res) => {
                if(err) return alert(err.data.message)


                res.brand.loaded = true;
                this.setBrand(res.brand)

                this.loading = false;
                    iziToast.success({
                      position: 'bottomCenter',
                      title: 'Domain Updated',
                  });

              });
             
        },   deleteCname(){
            this.loading = true;
            let payload = {
              query: {
                userId: this.getUser._id,
                name: this.getBrand.cname[0].name
              }
            };

              _system.services.user.deleteCname(payload, (err, res) => {
                if(err) return alert(err.data.message)

                res.brand.loaded = true;
                this.setBrand(res.brand)

                this.loading = false;
                    iziToast.success({
                      position: 'bottomCenter',
                      title: 'Domain Updated',
                  });

              });
             
        },
        upload(){
          document.getElementById('upload').click();
        },
        onFileChange(e){
          var files = e.target.files || e.dataTransfer.files;
          
          if(files[0] && files[0].size > 500000){
            return alert('Image size must be less than  500 kb')
          }

          var image = new Image();
          var reader = new FileReader();

          this.attachment = files[0];

          reader.onload = (e) => {
            console.log(e)
            this.attachmentPreview = e.target.result;
            this.image = this.attachmentPreview
          };

          reader.readAsDataURL(files[0]);
        },
        triggerSelection(_id){           
          let cloneCurrentWorkspaceSettings = {...this.currentWorkspaceSettings}
          if(cloneCurrentWorkspaceSettings.hiddenPlatforms.includes(_id)){
            cloneCurrentWorkspaceSettings.hiddenPlatforms.splice(cloneCurrentWorkspaceSettings.hiddenPlatforms.indexOf(_id),1)
          }else{
            cloneCurrentWorkspaceSettings.hiddenPlatforms.push(_id)
          }
          this.setCurrentWorkspaceSettings(cloneCurrentWorkspaceSettings)
        },
        updatePermissions(){

         db.collection('workspaces')
        .doc(this.currentWorkspace._id)
        .set(this.currentWorkspaceSettings)
        .then(() => {

          console.log('ws updated!')
          iziToast.success({
            position: 'bottomCenter',
            title: this.currentWorkspaceSettings.hiddenPlatforms.length + ' Platforms hidden',
          });
        }).catch((e)=>{
      
          alert('Error while saving the data, contact support.')
        })
        }
      },
      mounted() { 
        var parent = document.querySelector('#parent');

        var picker = new window.Picker({
          parent: parent,
          color: (this.currentWorkspace.color) ? this.currentWorkspace.color : 'rgb(53, 59, 72)',
          popup: 'top',
          editorFormat: 'hex'
        });

          // You can do what you want with the chosen color using two callbacks: onChange and onDone.
          picker.onChange = (color) => {
              this.color = color.rgbString
              this.currentWorkspace.color = color.rgbString
          };
        },
      created(){
        this.subdomain = this.getUser._id
        this.color = (this.currentWorkspace.color) ? this.currentWorkspace.color : 'rgb(53, 59, 72)'

            let menu = [
            { 
                _id: '5e469e39f9d2578b0f53e465',
                name: 'Gmail',
                removed: true
                },
                                {
                 _id: '5c0bcfb235563f46ca2921bd',
                name: 'Facebook' 
                },
              { 
                _id: '5c0bcfb335563f46ca2921cb',
                name: 'Instagram' 
                },
              { 
                _id: '5c0bcfb235563f46ca292149',
                name: 'Twitter' 
                },
              { 
                _id: '5e716de3bc83c01b553f1282',
                name: 'LinkedIn',
                image: 'linkedIn'
                },
              { 
                _id: '5c1109f435563f46ca8a7ad9',
                name: 'Youtube',
                sub: 'Youtube'
               },
              { 
                _id: '5dc592bd808a68c722761bd9',
                name: 'Email',
                sub: 'Email - SMTP/IMAP',
                image: 'email',
                url: 'email',
                removed: true
                },
              { 
                _id: '5e317dcfa36c3336dbb20880',
                name: 'WhatsApp',
                sub: 'WhatsApp',
                image: 'whatsapp',
                url: 'whatsapp'
               },
              { 
                _id: '60355634790f263eedb4e45b',
                name: 'Twilio',
                sub: 'WhatsApp',
                image: 'whatsapp',
                url: 'whatsapp',
                removed: true
               },
              { 
                _id: '5ee3c607d0e32c86e627f353',
                name: 'Google My Business',
                image: 'googleMyBusiness'
                },
              { 
                _id: '5d111648894b33a713625cc7',
                name: 'Google Play',
                image: 'playStore'
                },
              { 
                _id: '5e0761e79133ee6990836d1a',
                name: 'App Store',
                image: 'appStore'
                },
              { 
                _id: '5dc59278808a68c722760982',
                name: 'Phone',
                image: 'phone',
                removed: true
                },
              { 
                _id: '5df2dc5b1fffc3daf789719a',
                name: 'Document',
                image: 'documents2',
                removed: true
                },
              { 
                _id: '5fe1dde5ac16dacfd76becad',
                name: 'Live Chat',
                image: 'chat',
                removed: true
                }
            ]

            let localNetworks = _.cloneDeep(this.networks);

            localNetworks = _(localNetworks).filter( platform => {
              if(_.find(menu, { _id : platform._id } )){
                let customPlatform = _.find(menu, {_id : platform._id } );
                platform.index = _.findIndex(menu, { _id: platform._id })
                platform.removed = (customPlatform.removed) ? true : false;
                platform.name = (customPlatform.sub) ? customPlatform.sub : customPlatform.name
                platform.image = '/img/socialSvg/' + ((customPlatform.image) ? customPlatform.image : platform.name.toLowerCase().replace(/\s/g,'')) + '.svg'
                platform.isHidden = (_id) => {
                  return (this.currentWorkspaceSettings.hiddenPlatforms.includes(_id)) ? 'checked' : ''
                }
              return true
              }
            }).orderBy('index').value();

            this.setNetworks(localNetworks)


      let payload = {
        query: {
          userId: this.getUser._id
        }
      }

      _system.services.user.getUserById(payload, (err, res) => {
        if (err) console.log(err)

        let workspaceuser = _.find(this.workspaceusers, (workspaceuser) => workspaceuser.user.brand )
          if(workspaceuser){
            workspaceuser.user.brand.loaded = true
            this.setBrand(workspaceuser.user.brand);
          }

          let cname = _.chain(this.getBrand).get('cname.0.name').defaultTo('').value().replaceAll('.','')
            if(cname.length){
              db.collection('domains')
              .doc(cname)
              .get()
              .then(snapshot => {
                const document = snapshot.data()
                console.log(document)
                this.image = document.url
              }).catch((err)=>{
                this.image = '/img/logo_dark2.png'
              })
            }else{
              this.image = '/img/logo_dark2.png'
            }

      })


/*       db.collection('users')
        .doc('A98eq0qe8102e801')
        .set({...this.getUser})
        .then(() => {
          console.log('user updated!')
        }).catch(()=>{
          alert('Error while saving the data, contact support.')
        }) */
/*       db.collection('users').add({email: this.getUser.email}).then((e) => {
          console.log(e);
          console.log('user created!')
        }) */

        //let data = db.collection('users').get();
/*         db.collection('users')
        .doc(this.getUser._id)
        .get()
        .then(snapshot => {
          const document = snapshot.data()
          console.log('firebaseusers', document)
        }).catch(()=>{
          alert('Error reading one document.')
        }) */

        // retrieve a collection
  /*         db.collection('users')
            .get()
            .then(querySnapshot => {
              const documents = querySnapshot.docs.map(doc => doc.data())
              console.log(documents)
            }).catch(()=>{
            alert('Error while reading collection.')
          }) */
        //console.log('fireData', this.fireStoreData)
      }
	}
</script>

<template>

  <div style="height: 100%;" class="ui grid stackable">
    <div v-if="!currentWorkspace" style="position: absolute; top: 50%;left:45%;">
        <span style="font-size: 26px;"> ⏳ loading . . . </span>
    </div>

    <div style="height: 100%; background: #f3f3f3;" class="sixteen wide computer sixteen wide mobile column">
      <div class="ui grid">
        <div class="ten wide column centered">
                <h1>White-label Settings</h1>
                <div class="ui divider"></div>
                <p>For businesses who would like to manage multiple clients in a highly organized manner. That's why we put heavy emphasis on features like workspaces and white-label.</p>
                <div style="background: transparent;" class="ui basic segment">
                  <form v-if="!getBrand.subdomain || getBrand.subdomain && !getBrand.subdomain.length" class="ui large form">
                    <div style="line-height: 1.6;" class="field">
                      <h4>Step 1</h4>
                        <p>Click activate button and copy the given subdomain below and create a CNAME for your own subdomain.</p>
                      <div class="ui basic segment">
                        {{subdomain}}.juphy.com
                      </div>
                      
                    </div>

                    <div style="text-align: right;" class="field">
                        <div :class="(loading) ? 'loading disabled' : ''" class="ui fluid button" @click="saveSubdomain()">Activate</div>
                    </div>
                  </form>
                  
                  

                 <div v-if="getBrand.subdomain && getBrand.subdomain.length" class="ui segment">
                   <p>{{getBrand.subdomain[0].records[0].name}}.juphy.com</p>
                   <p>Copy the url in order to create CNAME for your own domain. For example, you can create a subdomain like inbox.yourdomain.com from your domain management system (GoDaddy, Namecheap etc.) and you can forward your subdomain to the {{getBrand.subdomain[0].records[0].name}}.juphy.com with a CNAME record.</p>
                   <button @click="deleteSubdomain()" :class="(loading) ? 'loading disabled' : ''"  class="ui red fluid button">Deactivate</button>
                 </div>

                </div>
                <div style="background: transparent;"  class="ui basic segment">
                  <form v-if="!getBrand.cname || getBrand.cname && !getBrand.cname.length" class="ui large form">
                    <div style="line-height: 1.6;" class="field">
                      <h4>Step 2</h4>
                      <p>In order to finish whitelabel activation, type your subdomain or domain below. Note: Please only type the name and extension like inbox.yourdomain.com or yourdomain.com do not need to type "www" and "http://"</p>
                      <input type="text" v-model="cname" placeholder="yourdomain.com">
                    </div>

                    <div style="text-align: right;" class="field">
                        <div :class="(loading) ? 'loading disabled' : ''" class="ui fluid button" @click="saveCname()">Activate Custom Domain</div>
                    </div>
                  </form>
                  <div v-if="getBrand.cname && getBrand.cname.length" class="ui segment">
                   <p>{{getBrand.cname[0].name}}</p>
                   <button @click="deleteCname()" :class="(loading) ? 'loading disabled' : ''" class="ui red fluid button">Deactivate</button>
                 </div>
                </div>

                <div style="background: transparent;" class="ui basic large segment">
                  <h4>Step 3</h4>
                  <p>Replace Juphy's logo with your own business logo.</p>
                  <form class="ui large form">
                    <div style="line-height: 1.6;" class="field">

                    </div>

                    <div  class="field">
                      <div :style="'background:' + color" style="width: 200px; margin: 0 auto; padding: 2rem;">
                        <img v-if="getBrand.loaded && image.length" @click="upload()" style="width: 100%;" class="ui centered image" :src="image">
                      </div>
                      
                      <div style="margin-top: 1rem;" class="ui mini basic fluid button" @click="upload()">Select image from computer</div>
                      <input id="upload" class="ui basic button" type="file" @change="onFileChange($event)" style="display: none;">
                    </div>
                    <div style="text-align: right;" class="field">
                      <div class="ui fluid button" :class="(getBrand.cname && getBrand.cname.length) ? '':'disabled'" @click="saveImage()">Update Image</div>
                    </div>
                  </form>
                </div>

                <div style="background: transparent;" class="ui basic large segment">
                  <h4>Permissions for {{currentWorkspace.name}} workspace (Optional)</h4>
                  <p>You can hide communication channels from your clients for this workspace, selected ones will be hidden from channels section.</p>

              <div v-if="currentWorkspaceSettings.loaded">
                <div v-show="!platform.removed" v-for="platform in networks" :key="platform._id">
                  <div @click="triggerSelection(platform._id)" class="checkboxInput">
                  <div :class="platform.isHidden(platform._id)" class="checkbox">
                    <i class="icon-check check icon"></i>
                  </div>
                    <div style="position: relative;" class="checkboxLabel">
                      <img :src="platform.image" style="width: 19px;height: 19px;border-radius: 20px;vertical-align: middle;border: 1px solid #fff;" alt="">
                      <span style="display: inline-block;">{{platform.name}}</span>
                    </div>
                  </div>
                </div>
              </div>

        <div class="ui fluid button" @click="updatePermissions()">Update permissions</div>
      </div>


        </div>
      </div>
      </div>

  </div>

</template>

<style scoped>

.checkboxInput {
    margin: 0 0 10px;
    cursor: pointer;
}

.checkboxInput {
    display: -webkit-box;
    display: flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    flex-direction: row;
    -webkit-box-align: center;
    align-items: center;
    cursor: pointer;
    -webkit-transition: all .1s ease-in-out;
    transition: all .1s ease-in-out;
}

.checkboxInput .checkbox {
    display: -webkit-box;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    min-width: 16px;
    width: 18px;
    height: 18px;
    border: 2px solid 
    #ddd;
    border-radius: 5px;
    -webkit-transition: all .1s ease-in-out;
    transition: all .1s ease-in-out;
    position:relative;
}

.checkboxInput .checkbox .icon-check {
    font-size: 10px;
    color: #aaa;
    opacity: 0;
    -webkit-transition: all .1s ease-in-out;
    transition: all .1s ease-in-out;
    -webkit-transform: translate(18%, -50%);
    transform: translate(-50%, -50%);
    position: absolute;
    left: 50%;
    bottom: 25%;
    height: 12px;
    top: 25%;
}
.checkboxInput .checkboxLabel {
    margin: 0 10px;
    font-size: 15px;
    line-height: 20px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    height: 22px;
}

.checkboxInput:hover .checkbox .icon-check {
    opacity: .3;
}

.checkboxInput .checkbox.checked .icon-check {
    color: #3960BD;
    opacity: 1;
}

.checkboxInput .checkbox.checked {
    border-color: #3960BD;
}

.modalWrapper {
   position: fixed; 
   top: 0; 
   right: 0; 
   bottom: 0; 
   left:0; 
   z-index: 9999; 
   overflow-x: hidden;
   overflow-y: scroll;
}
.modal {
   position: fixed; 
   top: 0; 
   right: 0; 
   bottom: 0; 
   left:0; 
   background: rgba(15, 17, 26, 0.35) none repeat scroll 0% 0%; 
   z-index: 9999; 
   overflow-x: hidden;
   overflow-y: scroll;
}

.radiusSegment {
  border-radius: 5px !important;
}

.cloud {
position: fixed;
background: rgba(0, 0, 0, 0.28) none repeat scroll 0% 0%;
left: 0px;
top: 0px;
bottom: 0px;
right: 0px;
z-index: 999;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/WhiteLabel.vue